import styled from 'styled-components'

export default styled.p`
  margin-right: 1rem;
  margin-bottom: 3px;
  text-transform: uppercase;
  font-variant: small-caps;
`



// WEBPACK FOOTER //
// ./src/shared/SmallHeader.js